import { render } from "./ContainerExtras.vue?vue&type=template&id=c96fd09e&scoped=true"
import script from "./ContainerExtras.vue?vue&type=script&lang=js"
export * from "./ContainerExtras.vue?vue&type=script&lang=js"

import "./ContainerExtras.vue?vue&type=style&index=0&id=c96fd09e&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96fd09e"]])

export default __exports__